// Recent searches in the search drawer: the search page passes its query in data-save; the last five
// queries on this device show as links. Storage can be unavailable, in which case the list stays hidden.
if (!customElements.get('recent-searches')) {
	class RecentSearches extends HTMLElement {
		static key = 'recent-searches';
		static max = 5;

		connectedCallback() {
			this.list = this.querySelector('.thb-predictive-search--recent-list');
			this.querySelector('.thb-predictive-search--recent-clear').addEventListener('click', () => this.clear());
			const terms = this.read();
			const current = (this.dataset.save || '').trim();
			if (current) {
				const next = [current, ...terms.filter((term) => term.toLowerCase() !== current.toLowerCase())].slice(0, RecentSearches.max);
				this.write(next);
				this.render(next);
			} else {
				this.render(terms);
			}
		}
		read() {
			try {
				const terms = JSON.parse(localStorage.getItem(RecentSearches.key));
				return Array.isArray(terms) ? terms.filter((term) => typeof term === 'string') : [];
			} catch (error) {
				return [];
			}
		}
		write(terms) {
			try {
				localStorage.setItem(RecentSearches.key, JSON.stringify(terms));
			} catch (error) {}
		}
		render(terms) {
			this.list.replaceChildren(...terms.map((term) => {
				const link = document.createElement('a');
				link.href = `${this.dataset.url}?q=${encodeURIComponent(term)}`;
				link.textContent = term;
				return link;
			}));
			this.hidden = terms.length === 0;
		}
		clear() {
			try {
				localStorage.removeItem(RecentSearches.key);
			} catch (error) {}
			this.render([]);
			// The Clear button was inside the now hidden list; keep focus in the open panel, on its field.
			this.closest('#Search-Drawer')?.querySelector('input[type="search"]')?.focus();
		}
	}
	customElements.define('recent-searches', RecentSearches);
}
